export default __webpack_public_path__ + "497ed911fe9c4fb905aaa590e51b9813.png";